import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7ea3ca0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-left" }
const _hoisted_2 = { class: "logo-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "left-time" }
const _hoisted_6 = { class: "weather" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 联系客服", -1))
const _hoisted_10 = { class: "left-space" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "space-info" }
const _hoisted_13 = { class: "space-temp" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "temp-text" }, "温度", -1))
const _hoisted_16 = { class: "temp-num" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "℃", -1))
const _hoisted_18 = { class: "space-env" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "env-text" }
const _hoisted_22 = {
  key: 0,
  class: "fotter"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "…", -1))
const _hoisted_28 = { class: "main-right" }
const _hoisted_29 = {
  key: 0,
  class: "work-btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_work_config = _resolveComponent("work-config")!
  const _component_manual_config = _resolveComponent("manual-config")!
  const _component_scenario_config = _resolveComponent("scenario-config")!
  const _component_manual_index = _resolveComponent("manual-index")!
  const _component_Air = _resolveComponent("Air")!
  const _component_Light = _resolveComponent("Light")!
  const _component_Curtain = _resolveComponent("Curtain")!
  const _component_work_overtime = _resolveComponent("work-overtime")!
  const _component_manual_overtime = _resolveComponent("manual-overtime")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_scenario_dailog = _resolveComponent("scenario-dailog")!
  const _component_detail = _resolveComponent("detail")!
  const _component_com_map = _resolveComponent("com-map")!
  const _component_contact = _resolveComponent("contact")!

  return (_openBlock(), _createElementBlock("div", {
    class: "main",
    style: _normalizeStyle({
      backgroundImage:
        'linear-gradient(0deg, rgba(69, 33, 0, 0.2), rgba(69, 33, 0, 0.2)), url(' +
        _ctx.padBgImg +
        ')',
      'background-repeat': 'no-repeat',
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "left-top",
        onTouchstart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gtouchstart($event))),
        onTouchmove: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gtouchmove())),
        onTouchend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showDeleteButton && _ctx.showDeleteButton(...args)))
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.logImg)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "logo-icon",
                src: _ctx.logImg,
                alt: ""
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "logo-icon",
                src: _ctx.parseImgUrl('ipdImages', 'shangeyun_logo.svg'),
                alt: ""
              }, null, 8, _hoisted_4))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.nowDate), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.nowWeek), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("img", {
            src: _ctx.outWeather.imgname,
            class: "weather-icon",
            alt: ""
          }, null, 8, _hoisted_7), [
            [_vShow, _ctx.outWeather.imgname]
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.outWeather.temperature ? _ctx.outWeather.temperature : "--") + "℃", 1)
        ]),
        _createElementVNode("div", {
          class: "weixiin",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showContact && _ctx.showContact(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.parseImgUrl('ipdImages', 'weixin.svg')
          }, null, 8, _hoisted_8),
          _hoisted_9
        ])
      ], 32),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, _toDisplayString(_ctx.officeData.localName), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              src: _ctx.parseImgUrl('ipdImages', 'template-icon.svg'),
              alt: ""
            }, null, 8, _hoisted_14),
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.officeData.temperature ? _ctx.officeData.temperature : "--"), 1),
              _hoisted_17
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.envlist, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["env-item", [
              index == 1 ? 'env-color' : '',
              item.bgColor ? 'env-item-radius' : '',
            ]]),
              style: _normalizeStyle([
              { background: item.bgColor ? item.bgColor : '' },
              { opacity: item.bgColor ? 0.8 : '' },
              { paddingLeft: index == 0 && item.bgColor ? '15px' : '' },
            ]),
              key: 'env' + index,
              onClick: ($event: any) => (_ctx.handleDetail(item))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _ctx.parseImgUrl('ipdImages', item.img),
                  alt: ""
                }, null, 8, _hoisted_20),
                _createElementVNode("span", null, _toDisplayString(item.name), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createTextVNode(_toDisplayString(item.num) + " ", 1),
                _createElementVNode("sup", null, _toDisplayString(item.unit), 1)
              ])
            ], 14, _hoisted_19))
          }), 128))
        ])
      ]),
      (_ctx.spaceData && _ctx.spaceData.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spaceData, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (index < 3)
                  ? (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["fotter-item", item.active ? 'fotter-item-active' : '']),
                      key: index + 'nav',
                      onClick: ($event: any) => (_ctx.changeSpace(item))
                    }, [
                      (item.active)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.parseImgUrl('ipdImages', 'rectangle-active.svg')
                          }, null, 8, _hoisted_24))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _ctx.parseImgUrl('ipdImages', 'rectangle1.svg')
                          }, null, 8, _hoisted_25)),
                      _createElementVNode("span", null, _toDisplayString(item.spaceName), 1)
                    ], 10, _hoisted_23))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256)),
            (_ctx.spaceData && _ctx.spaceData.length > 3)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "fotter-item-end",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.moreSpace && _ctx.moreSpace(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.parseImgUrl('ipdImages', 'rectangle-fotter.svg')
                  }, null, 8, _hoisted_26),
                  _hoisted_27
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_28, [
      (
          (_ctx.roomType === '开放' && _ctx.isWork) ||
          (_ctx.roomType === '会议室' && _ctx.scenarioArr && _ctx.scenarioArr.length)
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            (_ctx.roomType === '开放' && _ctx.isWork && _ctx.controlMode !== 1)
              ? (_openBlock(), _createBlock(_component_work_config, {
                  key: 0,
                  scenarioArr: _ctx.scenarioArr,
                  workkArr: _ctx.workkArr,
                  onCloseWork: _ctx.closeWork,
                  onTriggerWork: _ctx.triggerWork,
                  onSetForceOverTimeFlag: _ctx.setForceOverTimeFlag
                }, null, 8, ["scenarioArr", "workkArr", "onCloseWork", "onTriggerWork", "onSetForceOverTimeFlag"]))
              : _createCommentVNode("", true),
            (_ctx.roomType === '开放' && _ctx.isWork && _ctx.controlMode === 1)
              ? (_openBlock(), _createBlock(_component_manual_config, {
                  key: 1,
                  scenarioArr: _ctx.scenarioArr,
                  workkArr: _ctx.workkArr,
                  onCloseWork: _ctx.closeWork,
                  onTriggerWork: _ctx.triggerWork,
                  onSetForceOverTimeFlag: _ctx.setForceOverTimeFlag
                }, null, 8, ["scenarioArr", "workkArr", "onCloseWork", "onTriggerWork", "onSetForceOverTimeFlag"]))
              : _createCommentVNode("", true),
            (_ctx.roomType === '会议室' && _ctx.scenarioArr && _ctx.scenarioArr.length)
              ? (_openBlock(), _createBlock(_component_scenario_config, {
                  key: 2,
                  activeType: _ctx.activeType,
                  scenarioArr: _ctx.scenarioArr,
                  spaceId: _ctx.spaceInfo.spaceId,
                  projectId: _ctx.projectId,
                  onSetHeadScene: _ctx.setHeadScene
                }, null, 8, ["activeType", "scenarioArr", "spaceId", "projectId", "onSetHeadScene"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.controlMode === 1)
        ? (_openBlock(), _createBlock(_component_manual_index, {
            key: 1,
            onTriggerWork: _ctx.triggerWork,
            seviceEquipmentList: _ctx.seviceEquipmentList,
            forceOverTimeFlag: _ctx.forceOverTimeFlag,
            onUpdateAirTemp: _ctx.updateAirTemp,
            hasAir: _ctx.spaceExistenceDevice.airConditioner,
            airVolumes: _ctx.officeData.airVolumes,
            temperature: _ctx.officeData.temperature,
            spaceId: _ctx.spaceInfo.spaceId,
            projectId: _ctx.projectId,
            userIsControl: _ctx.userIsControl
          }, null, 8, ["onTriggerWork", "seviceEquipmentList", "forceOverTimeFlag", "onUpdateAirTemp", "hasAir", "airVolumes", "temperature", "spaceId", "projectId", "userIsControl"]))
        : _createCommentVNode("", true),
      (
          _ctx.controlMode != 1 &&
          (_ctx.officeData.temperature || _ctx.spaceExistenceDevice.airConditioner)
        )
        ? (_openBlock(), _createBlock(_component_Air, {
            id: "airId",
            key: "airId",
            onTriggerWork: _ctx.triggerWork,
            forceOverTimeFlag: _ctx.forceOverTimeFlag,
            onUpdateAirTemp: _ctx.updateAirTemp,
            hasAir: _ctx.spaceExistenceDevice.airConditioner,
            airVolumes: _ctx.officeData.airVolumes,
            temperature: _ctx.officeData.temperature,
            spaceId: _ctx.spaceInfo.spaceId,
            projectId: _ctx.projectId,
            isACATVA: _ctx.isACATVA,
            userIsControl: _ctx.userIsControl
          }, null, 8, ["onTriggerWork", "forceOverTimeFlag", "onUpdateAirTemp", "hasAir", "airVolumes", "temperature", "spaceId", "projectId", "isACATVA", "userIsControl"]))
        : _createCommentVNode("", true),
      (_ctx.spaceExistenceDevice.light && _ctx.spaceInfo.spaceId)
        ? (_openBlock(), _createBlock(_component_Light, {
            forceOverTimeFlag: _ctx.forceOverTimeFlag,
            controlMode: _ctx.controlMode,
            seviceEquipmentList: _ctx.seviceEquipmentList,
            onTriggerWork: _ctx.triggerWork,
            id: "lightId",
            key: "lightId",
            userIsControl: _ctx.userIsControl,
            spaceId: _ctx.spaceInfo.spaceId,
            projectId: _ctx.projectId
          }, null, 8, ["forceOverTimeFlag", "controlMode", "seviceEquipmentList", "onTriggerWork", "userIsControl", "spaceId", "projectId"]))
        : _createCommentVNode("", true),
      (_ctx.spaceExistenceDevice.curtain)
        ? (_openBlock(), _createBlock(_component_Curtain, {
            spaceId: _ctx.spaceInfo.spaceId,
            id: "curtainId",
            key: "curtainId",
            userIsControl: _ctx.userIsControl,
            projectId: _ctx.projectId
          }, null, 8, ["spaceId", "userIsControl", "projectId"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.isShowWork,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isShowWork) = $event)),
      position: "right",
      class: "popup-content",
      teleport: "#app"
    }, {
      default: _withCtx(() => [
        (_ctx.isShowWork && _ctx.controlMode !== 1)
          ? (_openBlock(), _createBlock(_component_work_overtime, {
              key: 0,
              spaceInfo: _ctx.spaceInfo,
              onCloseWork: _ctx.closeWork,
              projectId: _ctx.projectId,
              workkArr: _ctx.workkArr
            }, null, 8, ["spaceInfo", "onCloseWork", "projectId", "workkArr"]))
          : _createCommentVNode("", true),
        (_ctx.isShowWork && _ctx.controlMode === 1)
          ? (_openBlock(), _createBlock(_component_manual_overtime, {
              key: 1,
              seviceEquipmentList: _ctx.seviceEquipmentList,
              enterType: _ctx.enterType,
              deviceItem: _ctx.deviceItem,
              spaceInfo: _ctx.spaceInfo,
              onCloseWork: _ctx.closeWork,
              projectId: _ctx.projectId,
              workkArr: _ctx.workkArr
            }, null, 8, ["seviceEquipmentList", "enterType", "deviceItem", "spaceInfo", "onCloseWork", "projectId", "workkArr"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.isShowMetting,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isShowMetting) = $event)),
      position: "right",
      "close-on-click-overlay": false,
      class: "popup-content",
      teleport: "#app"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_scenario_dailog, {
          secenaroStatus: _ctx.secenaroStatus,
          onCloseDailog: _ctx.closeDailog
        }, null, 8, ["secenaroStatus", "onCloseDailog"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.isShowDetail,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isShowDetail) = $event)),
      position: "right",
      "close-on-click-overlay": true,
      class: "popup-content",
      teleport: "#app"
    }, {
      default: _withCtx(() => [
        (_ctx.isShowDetail)
          ? (_openBlock(), _createBlock(_component_detail, {
              key: 0,
              query: _ctx.detailQuery
            }, null, 8, ["query"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.isShowMap,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isShowMap) = $event)),
      class: "map-popup",
      position: "bottom",
      style: {"width":"100%","height":"70%"},
      "close-on-click-overlay": true,
      teleport: "#app"
    }, {
      default: _withCtx(() => [
        (_ctx.defaultSpace.spaceId && _ctx.isShowMap)
          ? (_openBlock(), _createBlock(_component_com_map, {
              key: 0,
              spaceData: _ctx.copySpaceData,
              spaceInfo: _ctx.defaultSpace,
              projectId: _ctx.projectId,
              floorId: _ctx.defaultSpace.floorId,
              buildingId: _ctx.defaultSpace.buildingId,
              onChangeSpace: _ctx.changeSpace
            }, null, 8, ["spaceData", "spaceInfo", "projectId", "floorId", "buildingId", "onChangeSpace"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_contact, {
      isShowContact: _ctx.isShowContact,
      onCloseDailog: _ctx.closeContactDailog
    }, null, 8, ["isShowContact", "onCloseDailog"])
  ], 4))
}